var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordedVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.691,
    height: 64,
    viewBox: "0 0 57.691 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.691,
    height: 64,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.17,17.191c5.892,7.259,12.019,12.962,12.491,19.184.471,6.175-4.713,12.868-10.652,18.147C41.116,59.848,34.423,63.807,27.636,64c-6.834.141-13.763-3.535-18.854-8.861A31.918,31.918,0,0,1,.062,35.385,35.651,35.651,0,0,1,6.8,12.76C11.846,5.5,19.812-1,26.646.128,33.528,1.212,39.231,9.979,45.17,17.191",
    transform: "translate(0.001 0)",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M141.98,153.5H117.966l23.959-5.534-1.223-5.3a2.742,2.742,0,0,0-3.276-2.077l-29.337,6.776A2.737,2.737,0,0,0,105.981,150h0l.007,23.017a2.762,2.762,0,0,0,2.759,2.763h30.5A2.762,2.762,0,0,0,142,173.017Zm-7.694-10.041,4.745,3.1-3.658.844-4.745-3.1Zm-7.381,1.705,4.745,3.1-3.659.844-4.744-3.1Zm-7.2,1.664,4.745,3.1-3.658.844-4.745-3.1Zm-7.36,1.7,4.742,3.1-3.658.844-4.743-3.095Zm26.895,24.492h-30.5V156.252h30.5Z",
    transform: "translate(-95.142 -126.146)",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.848,221.988l-3.658.844-4.743-3.095,3.659-.847Z",
    transform: "translate(-118.906 -196.513)",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.85,205.359l-3.658.844-4.745-3.1,3.658-.844Z",
    transform: "translate(-183.545 -181.583)",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,189.079l-3.659.844-4.744-3.1,3.658-.847Z",
    transform: "translate(-246.793 -166.967)",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.49,172.4l-3.658.844-4.745-3.1,3.658-.845Z",
    transform: "translate(-311.602 -151.993)",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.992,333.7v8.972l7.178-4.487Z",
    transform: "translate(-228.024 -299.586)",
    fill: "#02e2ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordedVideo);
export default __webpack_public_path__ + "static/media/recorded_video.546ee51c021e8860c34c02d1ac134e03.svg";
export { ForwardRef as ReactComponent };